import { AuthProvider, useAuth } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import './App.css';
import './styles/GlobalTheme.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AppProvider } from './context/AppContext';
import Navbar from './components/layout/Navbar';
import LandingPage from './pages/LandingPage';
import PricingPage from './pages/PricingPage';
import RegisterPage from './pages/RegisterPage';
import LoginPage from './pages/LoginPage';
import PaymentPage from './pages/PaymentPage';
import PaymentSuccessPage from './pages/PaymentSuccessPage';
import PaymentFailurePage from './pages/PaymentFailurePage';
import SubscriptionPage from './pages/SubscriptionPage';
import DashboardPage from './pages/DashboardPage';
import ProductsPage from './pages/ProductsPage';
import OrdersPage from './pages/OrdersPage';
import OrderViewPage from './pages/OrderViewPage';
import ExpensesPage from './pages/ExpensesPage';
import ReportsPage from './pages/ReportsPage';
import ClientsPage from './pages/ClientsPage';
import ProfilePage from './pages/ProfilePage';

function PrivateRoute({ children }) {
  const { user, authLoading } = useAuth();

  if (authLoading) return <div className="text-center mt-5">Carregando...</div>;
  if (!user) return <Navigate to="/login" replace />;

  return children;
}

function PublicRoute({ children }) {
  const { user, authLoading } = useAuth();

  if (authLoading) return <div className="text-center mt-5">Carregando...</div>;
  if (user) return <Navigate to="/dashboard" replace />;

  return children;
}

function AppLayout({ children }) {
  return (
    <div className="mg-app">
      <Navbar />
      <main className="mg-main-container">
        <div className="mg-content mg-animate-fade-in">
          {children}
        </div>
      </main>
    </div>
  );
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <AppProvider>
          <BrowserRouter>
            <Routes>
            {/* Rotas Públicas (sem Navbar) */}
            <Route
              path="/"
              element={
                <PublicRoute>
                  <LandingPage />
                </PublicRoute>
              }
            />
            <Route
              path="/planos"
              element={<PricingPage />}
            />
            <Route
              path="/registro"
              element={
                <PublicRoute>
                  <RegisterPage />
                </PublicRoute>
              }
            />
            <Route
              path="/login"
              element={
                <PublicRoute>
                  <LoginPage />
                </PublicRoute>
              }
            />

            {/* Rota pública de visualização de pedido */}
            <Route path="/pedido/:orderId" element={<OrderViewPage />} />

            {/* Rotas Privadas (com Navbar) */}
            <Route
              path="/dashboard"
              element={
                <PrivateRoute>
                  <AppLayout>
                    <DashboardPage />
                  </AppLayout>
                </PrivateRoute>
              }
            />
            <Route
              path="/produtos"
              element={
                <PrivateRoute>
                  <AppLayout>
                    <ProductsPage />
                  </AppLayout>
                </PrivateRoute>
              }
            />
            <Route
              path="/pedidos"
              element={
                <PrivateRoute>
                  <AppLayout>
                    <OrdersPage />
                  </AppLayout>
                </PrivateRoute>
              }
            />
            <Route
              path="/despesas"
              element={
                <PrivateRoute>
                  <AppLayout>
                    <ExpensesPage />
                  </AppLayout>
                </PrivateRoute>
              }
            />
            <Route
              path="/relatorios"
              element={
                <PrivateRoute>
                  <AppLayout>
                    <ReportsPage />
                  </AppLayout>
                </PrivateRoute>
              }
            />
            <Route
              path="/clientes"
              element={
                <PrivateRoute>
                  <AppLayout>
                    <ClientsPage />
                  </AppLayout>
                </PrivateRoute>
              }
            />
            <Route
              path="/assinatura"
              element={
                <PrivateRoute>
                  <AppLayout>
                    <SubscriptionPage />
                  </AppLayout>
                </PrivateRoute>
              }
            />
            <Route
              path="/perfil"
              element={
                <PrivateRoute>
                  <AppLayout>
                    <ProfilePage />
                  </AppLayout>
                </PrivateRoute>
              }
            />
            <Route
              path="/pagamento"
              element={
                <PrivateRoute>
                  <PaymentPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/pagamento/sucesso"
              element={
                <PrivateRoute>
                  <PaymentSuccessPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/pagamento/falha"
              element={
                <PrivateRoute>
                  <PaymentFailurePage />
                </PrivateRoute>
              }
            />
            <Route
              path="/pagamento/pendente"
              element={
                <PrivateRoute>
                  <PaymentSuccessPage />
                </PrivateRoute>
              }
            />
            </Routes>
          </BrowserRouter>
        </AppProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
